import { Grid } from "@mui/material";
import React, { Component } from "react";
import CtDtp from "./CustomTool/CtDtp";
import CtCmb from "./CustomTool/CtCmb";
import CtBtn from "./CustomTool/CtBtn";
import CtCheckBox from "./CustomTool/CtCheckBox";
import { withRouter } from "../HOC/withRouter";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
} from "../mapRedux/mapReduxProps";
import { fetchCustomerMaster } from "./API";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import { getFromToDate4AcYear } from "../SystemUtility/SystemUtility";

class CustomerDateWiseSales extends Component {
  state = {
    Type: [{ Type: "Summary" }, { Type: "Detail" }],
    Customer: [],
    formData: {
      cmbType: "Summary",
      dtpFromDate: "",
      dtpToDate: "",
      cmbCustomer: "",
    },
  };

  //#region Component
  componentDidMount() {
    document.title = "RA : Customer Date Wise Sales";
    this.props.setActiveMenu("CustomerDateWiseSales");
    this.getFinancialYearEndDateFromLocalStorage();
    this.loadData();
  }
  //#endregion Component
  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  loadData = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "LoadCustomerDetails",
        bint_acid: localStorage.getItem("acid"),
      };
      fetchCustomerMaster(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let Customer = res.data.CustomerList,
            rowsCount = Customer.length;
          this.setState({
            dataLoadStatus,
            Customer,
            rowsCount,
          });
        })
        .catch((error) => {
          console.log("Unknown error occurred in onCustomerLoad.", error);
        });
    });
  };

  getFinancialYearEndDateFromLocalStorage() {
    let dt = getFromToDate4AcYear(localStorage.getItem("ACY"));
    this.setState({
      formData: {
        ...this.state.formData,
        dtpFromDate: dt.firstDate,
        dtpToDate: dt.lastDate,
      },
    });
    // console.log("dt", dt);
  }

  render() {
    return (
      <form>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Customer Date Wise Sales</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtCmb
              id="cmbType"
              label="Type"
              value={this.state.formData.cmbType}
              items={this.state.Type}
              handleOnChange={this.handleOnChange}
              onKeyDown={this.props.onKeyDown}
              width={160}
              colID="Type"
            />
          </Grid>
          <Grid item>
            <CtDtp
              id="dtpFromDate"
              label="From Date"
              width="150"
              handleOnChange={this.handleOnChange}
              defaultValue={this.state.formData.dtpFromDate}
              value={this.state.formData.dtpFromDate}
              onKeyDown={this.props.onKeyDown}
              // nextCtrlID="dtpToDate"
            />
          </Grid>
          <Grid item>
            <CtDtp
              id="dtpToDate"
              label="To Date"
              width="150"
              handleOnChange={this.handleOnChange}
              defaultValue={this.state.formData.dtpToDate}
              value={this.state.formData.dtpToDate}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="cmbCustomer"
            />
          </Grid>
          <Grid item>
            <CtCmbEditable
              id="cmbCustomer"
              label="Customer"
              value={this.state.formData.cmbCustomer}
              items={this.state.Customer}
              onKeyDown={this.props.onKeyDown}
              width={320}
              maxLength={100}
              handleOnChange={this.handleOnChange}
              colID="vac_customer"
            />
          </Grid>
          <Grid
            item
            display={
              !this.state.formData.cmbCustomer ||
              this.state.formData.cmbCustomer.length === 0
                ? "none"
                : "block"
            }
          >
            <CtCheckBox
              id="chkCustomerWiseNewPage"
              name="chkCustomerWiseNewPage"
              label="Customer Wise New Page"
              // disabled={!this.state.formData.cmbCustomer || this.state.formData.cmbCustomer.length === 0}
              //   checked={this.state.formData.chkDefaultCompany}
              //   handleCheckChange={this.handleOnChkChange}
              // onKeyDown={this.props.onKeyDown}
              // nextCtrlID="txtTermsAndConditionLine1"
            ></CtCheckBox>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtBtn label="PDF" />
          </Grid>
          <Grid item>
            <CtBtn label="Date Wise" />
          </Grid>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenuToProps
)(withRouter(CustomerDateWiseSales));
